import React from "react";
import CardFeature from "../components/CardFeature";
import { features, featuresDetails, whys } from "../assets/features";
import FeatureDetails from "../components/FeatureDetails";
import CardWhy from "../components/CardWhy";

const Features = () => {
  return (
    <div className="flex flex-col items-center bg-secondary">
      <h1 className="md:text-4xl text-2xl font-bold text-primary">
        Why Choose Studycool?
      </h1>

      <div className="flex flex-col items-center md:my-12 px-12">
        <p className="text-center p-4 md:w-[500px] font-mono">
          Studycool is committed to reducing educational inequalities by
          providing accessible learning opportunities in underserved regions.
          Our efforts contribute to{" "}
          <a
            href="https://sdgs.un.org/goals/goal4"
            className="text-primary underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Quality Education
          </a>{" "}
          and{" "}
          <a
            href="https://sdgs.un.org/goals/goal10"
            className="text-primary underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Reduced Inequalities
          </a>
          , which are part of the United Nations' Sustainable Development Goals.
        </p>
        <div className="grid grid-cols-1  md:grid-cols-2 gap-6 my-12">
          {features.map((feature, index) => (
            <CardFeature feature={feature} key={index} />
          ))}
        </div>
      </div>
      <h1 className="md:text-4xl text-2xl font-bold text-primary mt-6">
        How it works
      </h1>
      {featuresDetails.map((detail, i) => (
        <FeatureDetails detail={detail} key={i} />
      ))}
      <h1 className="md:text-4xl text-2xl font-bold text-primary mt-6">
        Added Value of Studycool
      </h1>
      <p className="md:text-xl text-sm text-gray">
        Studycool is a decentralized application (Dapp)
      </p>

      <div className="grid grid-cols-1  md:grid-cols-2 gap-6 my-12">
        {whys.map((why, i) => (
          <CardWhy why={why} key={i} />
        ))}
      </div>
      <img
        loading="lazy"
        src="/images/down.svg"
        className="w-full bg-primary"
        alt="waves"
      />
    </div>
  );
};

export default Features;
